module.exports = {"member":"Membro","collaborator":"Collaboratore","moderator":"Moderatore","admin":"Amministratore"};